import { intervalToDuration } from "date-fns";

/**
 * Получить время отводимое для ввода кода из СМС
 *
 * @param {Number} remainingSeconds
 */
export function getRemainingTime(remainingSeconds) {
  const initialTime = intervalToDuration({ start: remainingSeconds * 1000, end: 0 });
  const minutes = initialTime.minutes ? `${initialTime.minutes}:` : "";
  let seconds;

  if (initialTime.minutes) {
    if (initialTime.seconds) {
      if (initialTime.seconds <= 9) {
        seconds = `0${initialTime.seconds}`;
      } else {
        seconds = initialTime.seconds;
      }
    } else {
      seconds = "00";
    }
  } else {
    seconds = initialTime.seconds;
  }

  return `${minutes}${seconds}`;
}
